import { useNavigate } from 'react-router-dom';
import styles from './Relatorios/Relatorios.module.css';

// ============================================================
// Hub de Relatórios — apresenta os relatórios disponíveis em
// formato de cards. Cada card leva para uma sub-rota dedicada.
// ============================================================

const RELATORIOS = [
  {
    rota: '/relatorios/inventario',
    icone: '📦',
    titulo: 'Inventário (snapshot)',
    desc: 'Estoque atual consolidado de todos os produtos por estoque. Ideal para conferência física.',
  },
  {
    rota: '/relatorios/minimo',
    icone: '⚠️',
    titulo: 'Abaixo do Mínimo',
    desc: 'Posições com quantidade abaixo do nível mínimo cadastrado. Use para planejar reposição.',
  },
  {
    rota: '/relatorios/movimentacoes',
    icone: '📋',
    titulo: 'Movimentações por Período',
    desc: 'Histórico de entradas, saídas, devoluções e transferências em um intervalo de datas.',
  },
  {
    rota: '/relatorios/consumo-os',
    icone: '🗂️',
    titulo: 'Consumo por OS',
    desc: 'Quanto de cada produto foi consumido em cada ordem de serviço. Útil para custeio.',
  },
];

export default function Relatorios() {
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.topbar}>
        <div>
          <div className={styles.pageTitle}>Relatórios</div>
          <div className={styles.pageSub}>
            Análises gerenciais. Todos exportam em PDF e Excel.
          </div>
        </div>
      </div>

      <div className={styles.hubGrid}>
        {RELATORIOS.map((rel) => (
          <div
            key={rel.rota}
            className={styles.hubCard}
            onClick={() => navigate(rel.rota)}
          >
            <div className={styles.hubCardIcon}>{rel.icone}</div>
            <div className={styles.hubCardTitulo}>{rel.titulo}</div>
            <div className={styles.hubCardDesc}>{rel.desc}</div>
          </div>
        ))}
      </div>
    </>
  );
}
